// extracted by mini-css-extract-plugin
export default {"container":"ButtonAmazon_container__84VZK"};